import {Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getKbaStatusStyle} from "../../utils/kba";

const KbaStatusBadge = ({status, fallback = "-"}) => {
  const {t} = useTranslation();
  const badge = (
    <span
      style={{
        ...getKbaStatusStyle(status),
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        borderRadius: "4px",
        padding: "2px 8px",
        fontFamily: "Gilroy-Medium",
        width: "fit-content",
      }}
    >
      {status ? t(`Kba.status.${status}`) : fallback}
    </span>
  );

  if (!status) {
    return badge;
  }

  return (
    <Tooltip
      title={<div style={{fontSize: 14}}>{t(`Kba.statusInfo.${status}`)}</div>}
      arrow
      placement="top"
    >
      {badge}
    </Tooltip>
  );
};

export default KbaStatusBadge;
